import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useEnrollStudentCertificateApi, useGetStudentCertificateApi } from '@/api/mypage.ts';
import FileItem from '@/components/common/Input/InputFile/FileItem.tsx';
import InputFile from '@/components/common/Input/InputFile/InputFile.tsx';
import { MYPAGE_RAW_CERT_STATUS_FAILED, MYPAGE_RAW_CERT_STATUS_FALSE } from '@/constants/mypage';
import { useLoadingStore } from '@/store/loadingStore.ts';
import { useToastStore } from '@/store/toastStore.ts';
import { formatBytesToKB } from '@/utils/formatting.ts';

import * as S from './style.ts';

const EnrollmentCert: React.FC = () => {
	const [uploadedFile, setUploadedFile] = useState<File | null>(null);
	const { t } = useTranslation();

	const { openToast } = useToastStore();
	const loadingStore = useLoadingStore();

	const { mutateAsync: enrollStudentCertificate } = useEnrollStudentCertificateApi();

	const handleSubmitEnrollment = async () => {
		if (confirm(t('mypage.enrollment.confirmSubmit'))) {
			const formData = new FormData();
			uploadedFile && formData.append('file', uploadedFile);

			if (uploadedFile === null) alert(t('mypage.enrollment.alertUploadFirst'));
			try {
				await enrollStudentCertificate(formData);
				openToast({
					icon: 'alert',
					content: 'common.toast.registered',
					showTime: 3000,
				});
				refetchStudentCertificateData();
				setUploadedFile(null);
			} catch {
				alert(t('common.alerts.registerFailed'));
			}
		}
	};
	const { data: studentCertificateData, refetch: refetchStudentCertificateData, isFetching: isFetechingStudentCertificate } = useGetStudentCertificateApi();

	useEffect(() => {
		if (isFetechingStudentCertificate) {
			loadingStore.onLoading();
		} else {
			loadingStore.offLoading();
		}
	}, [isFetechingStudentCertificate]);

	return (
		<S.FormContainer>
			<S.Container>
				<S.Title>{t('mypage.enrollment.title')}</S.Title>
				<S.FormGroup>
					<S.Label htmlFor="files">{t('mypage.enrollment.fileLabel')}</S.Label>
					<InputFile file={uploadedFile} setFile={setUploadedFile} />
					{studentCertificateData?.file_pk && (
						<FileItem
							fileName={studentCertificateData?.file_name ?? t('common.file.noName')}
							fileSize={formatBytesToKB(studentCertificateData?.file_size) ?? t('common.file.noSize')}
							willBeDeletedItem={uploadedFile !== null}
						/>
					)}
				</S.FormGroup>
			</S.Container>
			<S.EditButton onClick={handleSubmitEnrollment} disabled={uploadedFile === null}>
				{t('common.actions.register')}
			</S.EditButton>
			{studentCertificateData &&
				studentCertificateData.member_student_certificate_yn &&
				studentCertificateData.member_student_certificate_yn !== MYPAGE_RAW_CERT_STATUS_FALSE && (
					<S.CertState className={studentCertificateData?.member_student_certificate_yn !== MYPAGE_RAW_CERT_STATUS_FAILED ? 'normal' : 'error'}>
						{t(
							studentCertificateData.member_student_certificate_yn === MYPAGE_RAW_CERT_STATUS_FAILED
								? 'mypage.enrollment.status.failed'
								: 'mypage.enrollment.status.completed'
						)}
					</S.CertState>
				)}
		</S.FormContainer>
	);
};

export default EnrollmentCert;
